import React from 'react'
import './index.css'
import './fonts/JoystixMonospace.ttf'
import App from './App'
import ReactDOM from 'react-dom/client'
import { createHashRouter, RouterProvider } from 'react-router-dom'
// import reportWebVitals from './reportWebVitals';

const router = createHashRouter([
  {
    path: '/load/:loadConfig',
    element: <App />,
  },
  {
    path: '/*',
    element: <App />,
  },
])
const container = document.getElementById('root')

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
